import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getAnalyticsPageName,
  syncSessionRecording,
  trackMetaPixelPageView,
  trackPageView,
} from '../utils/analytics';

/**
 * Tracks page views on pathname changes and avoids duplicate fires for the same path.
 * Meta Pixel's PageView fires on unauthenticated acquisition routes only;
 * GA4/Mixpanel's trackPageView stays scoped to known main tenant portal routes.
 */
export const usePageAnalytics = (): void => {
  const { pathname } = useLocation();
  const lastTrackedPathRef = useRef<string | null>(null);

  useEffect(() => {
    const normalized = pathname.replace(/\/$/, '') || '/';
    if (lastTrackedPathRef.current === normalized) return;
    lastTrackedPathRef.current = normalized;

    trackMetaPixelPageView(pathname);
    syncSessionRecording(pathname);

    const pageName = getAnalyticsPageName(pathname);
    if (!pageName) return;

    trackPageView(pageName, { path: normalized });
  }, [pathname]);
};
